import { AbstractControl, AsyncValidatorFn } from '@angular/forms';
import { map } from 'rxjs';
import { ClientsResponse } from '../../tenants/models/clients-response.model';
import { TenantService } from '../../tenants/services/tenants.service';

export class ClientValidator {
  static createUniqueClientValidator(
    tenantService: TenantService,
    tenantId: string
  ): AsyncValidatorFn {
    return (control: AbstractControl) => {
      const clientName: string = control.value;
      return tenantService.getTenantClients(tenantId).pipe(
        map((response: ClientsResponse) => {
          const clientNames = response.data.map((c) => c.name);
          const client = clientNames.find((c) => c === clientName);
          return client ? { clientExists: true } : null;
        })
      );
    };
  }
}
